function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import React, { cloneElement } from 'react'; // import PropTypes from 'prop-types';

import classNames from 'classnames';
import { KZUIComponent, Icon } from '@kuaizhan/kui';

var HeaderPulldown = /*#__PURE__*/function (_KZUIComponent) {
  _inherits(HeaderPulldown, _KZUIComponent);

  var _super = _createSuper(HeaderPulldown);

  function HeaderPulldown(props) {
    var _this;

    _classCallCheck(this, HeaderPulldown);

    _this = _super.call(this, props);

    _this.autoBind('pushRef');

    _this.itemDoms = [];
    return _this;
  }

  _createClass(HeaderPulldown, [{
    key: "pushRef",
    value: function pushRef(dom) {
      this.itemDoms.push(dom);
    } // 计算条目子级菜单的定位位置

  }, {
    key: "computeSubDomsPt",
    value: function computeSubDomsPt() {
      this.itemDoms.forEach(function (itemDom) {
        if (itemDom) {
          var itemSubContentDom = itemDom.querySelector('.pulldown-content');

          if (itemSubContentDom) {
            var itemSubTriangleDom = itemDom.querySelector('.pulldown-triangle');
            var itemDomHeight = parseFloat(itemDom.getBoundingClientRect().height); // 子级菜单相对视口左上角的top距离

            var subDomTop = parseFloat(itemSubContentDom.getBoundingClientRect().top); // 子级菜单定位，bottom位置

            var subDomPtBottom = parseFloat(window.getComputedStyle(itemSubContentDom).bottom.slice(0, -2));

            if (subDomTop < 0) {
              // 设置定位，bottom位置
              itemSubContentDom.style.bottom = "".concat(subDomTop + subDomPtBottom, "px"); // 设置子级菜单左侧三角icon的位置

              itemSubTriangleDom.style.bottom = "".concat(itemDomHeight / 2 - (subDomTop + subDomPtBottom) - 6, "px");
              return;
            } // 设置子级菜单左侧三角icon的位置


            itemSubTriangleDom.style.bottom = "".concat(itemDomHeight / 2 - subDomPtBottom - 6, "px");
          }
        }
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.computeSubDomsPt();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.computeSubDomsPt();
    } // 渲染一级菜单

  }, {
    key: "renderFirstLevelMenu",
    value: function renderFirstLevelMenu() {
      var list = this.props.list;
      return this.renderPullDownList(list);
    } // 渲染二级菜单

  }, {
    key: "renderTwoLevelMenu",
    value: function renderTwoLevelMenu() {
      var list = this.props.list;
      var twoLevelList = [];

      if (Array.isArray(list) && list.length > 0) {
        twoLevelList.push(this.renderPullDownList(list));
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "pulldown-wrapper"
      }, twoLevelList.map(function (listComp, index) {
        return cloneElement(listComp, {
          key: index
        });
      }));
    } // 渲染下拉列表

  }, {
    key: "renderPullDownList",
    value: function renderPullDownList(list) {
      var _this2 = this;

      var curPage = this.props.curPage;

      if (Array.isArray(list) && list.length > 0) {
        var listContent = list.map(function (item, index) {
          var listCls = classNames(_defineProperty({
            'pulldown-item': true
          }, "".concat(item.classNames), !!item.classNames));
          return /*#__PURE__*/React.createElement("li", {
            className: item.text === curPage ? "".concat(listCls, " cur") : listCls,
            key: index,
            ref: _this2.pushRef
          }, /*#__PURE__*/React.createElement("a", {
            className: "item-link",
            href: item.link
          }, /*#__PURE__*/React.createElement("div", {
            className: "link-text-wrap"
          }, /*#__PURE__*/React.createElement("div", {
            className: "link-text"
          }, item.text), item.desc ? /*#__PURE__*/React.createElement("div", {
            className: "link-desc"
          }, item.desc) : null), item.iconClass ? /*#__PURE__*/React.createElement("i", {
            className: "link-icon ".concat(item.iconClass)
          }) : null), // 相应条目，存在子级菜单
          item.subList && item.subList.length ? /*#__PURE__*/React.createElement("div", {
            className: "pulldown-content"
          }, /*#__PURE__*/React.createElement("div", {
            className: "pulldown-triangle"
          }), item.subList ? _this2.renderPullDownList(item.subList) : null) : null);
        });
        return /*#__PURE__*/React.createElement("ul", {
          className: "pulldown-list"
        }, listContent);
      }

      return null;
    }
  }, {
    key: "renderList",
    value: function renderList() {
      var type = this.props.type;

      if (type === 'sub') {
        // 渲染二级导航
        return this.renderTwoLevelMenu();
      } // 渲染一级导航


      return this.renderFirstLevelMenu();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          type = _this$props.type,
          curPage = _this$props.curPage;
      var contentClassName = type === 'sub' ? 'pulldown-content sub' : 'pulldown-content';
      return /*#__PURE__*/React.createElement("div", {
        className: "header-pulldown",
        ref: this.storeRef('pulldown')
      }, /*#__PURE__*/React.createElement("div", {
        role: "button",
        tabIndex: 0,
        className: "pulldown-btn",
        onClick: this.handleClickBtn
      }, curPage, /*#__PURE__*/React.createElement(Icon, {
        className: "pulldown-arrow",
        iconClass: "kz-e-nav-pull-down"
      })), /*#__PURE__*/React.createElement("div", {
        className: contentClassName
      }, /*#__PURE__*/React.createElement("div", {
        className: "pulldown-triangle"
      }), this.renderList()));
    }
  }]);

  return HeaderPulldown;
}(KZUIComponent);

export default HeaderPulldown;